import useStyles from './styles';
import Icon from '../../components/Icon/Icon';
import { Spaced } from '../../components/Spaced/Spaced';
import { Row } from '../../components/Grid/Grid';
import Text from '../../components/Text/Text';
import useCart from './useCart';
import { BackIconButton } from '../App/Back';
import CartHeaderLoading from './CartHeaderLoading';
import AppLoading from '../App/AppLoading';

function UserData() {
  const classes = useStyles();
  const cart = useCart();

  return (
    <div className={classes.userDataContainer}>
      <Row>
        <Icon name="userCircle" className={classes.userIcon} />
        <Text type="smallWhite">{cart.user.email}</Text>
      </Row>
    </div>
  );
}

function TopBar() {
  const classes = useStyles();

  return (
    <Spaced size="medium">
      <Row justifyContent="space-between">
        <BackIconButton />
        <Icon name="appLogo" className={classes.icon} />
      </Row>
    </Spaced>
  );
}

function CartHeader() {
  const classes = useStyles();

  return (
    <div className={classes.header}>
      <AppLoading loadingComponent={<CartHeaderLoading />}>
        <TopBar />
        <UserData />
      </AppLoading>
    </div>
  );
}

export default CartHeader;
